import {Box, Divider} from "@mui/material";

import {designColors} from "~/ui";

export const BmCardViewSectionDividerNew: React.FC = () => {
  return (
    <Box sx={{paddingTop: "6px", paddingBottom: "5px", height: "12px"}}>
      <Divider sx={{border: "none", background: designColors.grey_2, height: "1px"}} />
    </Box>
  );
};
